/*
 * Copyright (c) 2020 NOOGA DEVELOPMENT, All rights reserved.
 * Author Raman Kremko <raman.kremko@noogadev.com>
 */

import { fields, factoryTBuilder } from 'factory-t';
import { factoryT } from 'factory-t/build';
import { OperatorCashBoxesStatDto, RegistryByTaxationTypeDto } from './dashBoardClient.typings';
import { TAXATION_TYPES } from '../companies/companiesClient.typings';

export const operatorsCashBoxesStat = factoryTBuilder<OperatorCashBoxesStatDto>({
    taxNumber: fields.index(),
    name: fields.string(),
    active: 700,
    inactive: 520,
    blocked: 170,
    notBlocked: 610,
    invalidTime: 800,
    total: 2000,
    registeredThisYear: 400,
})
    .setFieldFactory(
        'name',
        (ctx) =>
            `Operator${ctx.inject('taxNumber')} long name: Lorem ipsum dolor sit amet, consectetur adipiscing elit`,
    )
    .setFieldFactory('active', () => Math.round(Math.random() * 1000))
    .setFieldFactory('inactive', () => Math.round(Math.random() * 1000))
    .setFieldFactory('blocked', () => Math.round(Math.random() * 1000))
    .setFieldFactory('notBlocked', () => Math.round(Math.random() * 1000))
    .setFieldFactory('invalidTime', () => Math.round(Math.random() * 1000))
    .setFieldFactory(
        'total',
        (ctx) =>
            ctx.inject('active') +
            ctx.inject('inactive') +
            ctx.inject('blocked') +
            ctx.inject('notBlocked') +
            ctx.inject('invalidTime'),
    )
    .factory();

export const registryByTaxationType = factoryT<RegistryByTaxationTypeDto>({
    taxationType: fields.sequence([...TAXATION_TYPES, 'EMPTY']),
    count: (ctx) => Math.round(Math.random() * ctx.index * 100),
});
